<script>
import { Doughnut, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  props: ["options"],
  mounted() {
    let dataCollection = {
      // labels: ["Hombre", "Mujer", "Indeterminado"],
      labels: ["Hombres", "Mujeres"],
      datasets: [
        {
          backgroundColor: ["#F56565", "#ED8936", "#ECC94B"],
          pointBackgroundColor: "white",
          borderWidth: 1,
          pointBorderColor: "#249EBF",
          // data: [this.chartData.H, this.chartData.M, this.chartData.U]
          data: [this.chartData.H, this.chartData.M]
        }
      ]
    };

    this.renderChart(dataCollection, this.options);
  }
};
</script>
